import React, { memo } from "react";
import {
  Input,
  InputNumber,
  Row,
  Col,
  Form,
  DatePicker,
  Button,
  message,
  Select,
} from "antd";
import moment from "moment";
import relationshipListData from "../../assets/data/relationship.data.json";
import WaiverService from "../../services/WaiverService"
const { TextArea } = Input;
const Option = Select;

const ScholarshipForm = () => {
  const [form] = Form.useForm();

  const rules = {
    fullName: [
      {
        required: true,
        message: "Please enter full name",
        whitespace: true,
      },
    ],
    dob: [
      {
        required: true,
        message: "Please select date of birth",
      },
    ],
    email: [
      {
        required: true,
        message: "Please enter email",
      },
      {
        validator: (_, value) => {
          if (
            !value ||
            /^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(value)
          ) {
            return Promise.resolve();
          } else {
            return Promise.reject("Please enter a valid email");
          }
        },
      },
    ],
    contact: [
      {
        required: true,
        message: "Please enter contact",
      },
      {
        validator: (_, value) => {
          if (!value || /^[0-9]{10}$/.test(value)) {
            return Promise.resolve();
          } else {
            return Promise.reject("Please enter a valid mobile number");
          }
        },
      },
    ],
    currentSchool: [
      {
        required: true,
        message: "Please enter Current School",
        whitespace: true,
      },
    ],
    previousSchool: [
      {
        required: true,
        message: "Please enter Previous Schools",
        whitespace: true,
      },
    ],
    Address: [
      {
        required: true,
        message: "Please enter Address",
        whitespace: true,
      },
    ],
    academicAchievements: [
      {
        required: true,
        message: "Please enter Academic Achievements",
        whitespace: true,
      },
    ],
    annualIncome: [
      {
        required: true,
        message: "Please Enter annual Income",
        whitespace: true,
      },
    ],
    dependents: [
      {
        required: true,
        message: "Please Enter Number of dependents",
        whitespace: true,
      },
    ],
    financialNeed: [
      {
        required: true,
        message: "Please Enter Financia lNeed",
        whitespace: true,
      },
    ],
    whyScholarship: [
      {
        required: true,
        message: "Please Enter Why Scholarship Need",
        whitespace: true,
      },
    ],
    careerGoals: [
      {
        required: true,
        message: "Please Enter Career Goals ",
        whitespace: true,
      },
    ],
    ref1Name: [
      {
        required: true,
        message: "Please Enter Refrence Full Name ",
        whitespace: true,
      },
    ],
    ref1Relation: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (value !== "0" && value !== undefined) {
            return Promise.resolve();
          }
          return Promise.reject("Please select relationship");
        },
      }),
    ],
    signature: [
      {
        required: true,
        message: "Please Enter signature ",
        whitespace: true,
      },
    ],
    academicPeriod: [
      {
        required: true,
        message: "Please Enter Academic Period ",
        whitespace: true,
      },
    ],
    formDate: [
      {
        required: true,
        message: "Please select date of birth",
      },
    ],
  };

  const onFinish =() => {
    form
    .validateFields()
    .then(async (values) => { 
        const payload = {
            id: 0,
            fullName: values.fullName,
            dateOfBirth: values.dob,
            emailAddress: values.email,
            phoneNumber: values.phone,
            address: values.address,
            currentSchool: values.currentSchool,
            previousSchoolsAttended: values.previousSchools,
            academicAchievements: values.academicAchievements,
            familyAnnualIncome: values.annualIncome,
            numberOfDependents: values.dependents,
            financialNeedStatement: values.financialNeed,
            whyDoYouDeserveThisScholarship: values.whyScholarship,
            careerGoals: values.careerGoals,
            reference1Name: values.ref1Name,
            reference1Relationship: values.ref1Relation.toString(),
            reference1Contact: values.ref1Contact,
            reference2Name: values.ref2Name,
            reference2Relationship: values.ref2Relation.toString(),
            reference2Contact: values.ref2Contact,
            applicantSignature: values.signature,
            applicationDate: values.formDate
          };
          try {
            const res = await WaiverService.waviedOffRequest(payload);
            console.log("res", res)
            if(res?.data.statusCode === 200){
                message.success("Waived off Application Sent");
                form.resetFields();
                window.scroll(0, 0)
            }
            if(res?.data.statusCode === 409){
                message.error("Email already exits")
            }
          } catch (error) {
            console.log("error orrrur during wavied off application", error)
          }
    })
  };

  return (
    <div>
      <h2 className="widget-title text-left">Scholarship Application Form</h2>
      <div className="enrollment-form">
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          className="ant-advanced-search-form"
        >
          <Row gutter={24}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="fullName"
                label="Full Name"
                rules={rules.fullName}
              >
                <Input placeholder="Full Name" maxLength={100} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="dob" label="Date of Birth" rules={rules.dob}>
                <DatePicker
                  placeholder="MM/DD/YYYY"
                  format="MM/DD/YYYY"
                  className="w-100"
                  disabledDate={(current) =>
                    current && current > moment().endOf("day")
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="email" label="Email Address" rules={rules.email}>
                <Input placeholder="Email Address" maxLength={50} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="phone"
                label="Phone Number"
                rules={rules.contact}
              >
                <Input
                  placeholder="Mobile Number"
                  maxLength={10}
                  onKeyDown={(event) => {
                    if (
                      event.key !== "Delete" &&
                      event.key !== "Backspace" &&
                      event.key !== "ArrowLeft" &&
                      event.key !== "ArrowRight" &&
                      !/[0-9]/.test(event.key)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="currentSchool"
                label="Current School"
                rules={rules.currentSchool}
              >
                <Input placeholder="Current School" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="previousSchools"
                label="Previous Schools Attended"
                rules={rules.previousSchool}
              >
                <Input placeholder="Previous Schools" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={24}>
              <Form.Item name="address" label="Address" rules={rules.Address}>
                <TextArea placeholder="Address" rows={2} maxLength={200} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name="academicAchievements"
                label="Academic Achievements"
                rules={rules.academicAchievements}
              >
                <TextArea
                  rows={2}
                  placeholder="List your academic achievements"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="annualIncome"
                label="Family Annual Income"
                rules={rules.annualIncome}
              >
                <Input
                  placeholder="Family Annual Income"
                  maxLength={8}
                  onKeyDown={(event) => {
                    if (
                      event.key !== "Delete" &&
                      event.key !== "Backspace" &&
                      event.key !== "ArrowLeft" &&
                      event.key !== "ArrowRight" &&
                      !/[0-9]/.test(event.key)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="dependents"
                label="Number of Dependents"
                rules={rules.dependents}
              >
                <Input
                  placeholder="Number of Dependents"
                  maxLength={2}
                  onKeyDown={(event) => {
                    if (
                      event.key !== "Delete" &&
                      event.key !== "Backspace" &&
                      event.key !== "ArrowLeft" &&
                      event.key !== "ArrowRight" &&
                      !/[0-9]/.test(event.key)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name="financialNeed"
                label="Financial Need Statement"
                rules={rules.financialNeed}
              >
                <TextArea placeholder="Explain your financial need" rows={2} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="whyScholarship"
                label="Why do you deserve this scholarship?"
                rules={rules.whyScholarship}
              >
                <TextArea placeholder="Your reason" rows={2} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="careerGoals"
                label="Career Goals"
                rules={rules.careerGoals}
              >
                <TextArea placeholder="Your career goals" rows={2} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="ref1Name"
                label="Reference 1 - Name"
                rules={rules.ref1Name}
              >
                <Input placeholder="Name" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="ref1Relation"
                label="Reference 1 - Relationship"
                rules={rules.ref1Relation}
              >
                <Select
                  placeholder="Reference 1 - Relationship"
                  defaultValue="Relationship"
                >
                  <Option value="0">Relationship</Option>
                  {relationshipListData.map((elm) => (
                    <Option key={elm.id} value={elm.id}>
                      {elm.title}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="ref1Contact"
                label="Reference 1 - Contact"
                rules={rules.contact}
              >
                <Input
                  placeholder="Reference 1 - Contact"
                  maxLength={10}
                  onKeyDown={(event) => {
                    if (
                      event.key !== "Delete" &&
                      event.key !== "Backspace" &&
                      event.key !== "ArrowLeft" &&
                      event.key !== "ArrowRight" &&
                      !/[0-9]/.test(event.key)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="ref2Name" label="Reference 2 - Name" rules={rules.ref1Name}>
                <Input placeholder="Name" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="ref2Relation" label="Reference 2 - Relationship" rules={rules.ref1Relation}>
                <Select
                  placeholder="Reference 2 - Relationship"
                  defaultValue="Relationship"
                >
                  <Option value="0">Relationship</Option>
                  {relationshipListData.map((elm) => (
                    <Option key={elm.id} value={elm.id}>
                      {elm.title}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="ref2Contact" label="Reference 2 - Contact" rules={rules.contact}>
                <Input
                  placeholder="Reference 2 - Contact"
                  maxLength={10}
                  onKeyDown={(event) => {
                    if (
                      event.key !== "Delete" &&
                      event.key !== "Backspace" &&
                      event.key !== "ArrowLeft" &&
                      event.key !== "ArrowRight" &&
                      !/[0-9]/.test(event.key)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                label="Applicant Signature"
                name="signature"
                rules={rules.signature}
              >
                <Input placeholder="Applicant Signature" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="formDate" label="Date" rules={rules.formDate}>
                <DatePicker format="MM/DD/YYYY" className="w-100" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="academicPeriod"
                label="Which academic year are you applying for?"
                rules={rules.academicPeriod}
              >
                <Input
                  placeholder="e.g. Fall 2025"
                  maxLength={4}
                  onKeyDown={(event) => {
                    if (
                      event.key !== "Delete" &&
                      event.key !== "Backspace" &&
                      event.key !== "ArrowLeft" &&
                      event.key !== "ArrowRight" &&
                      !/[0-9]/.test(event.key)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row justify="end">
            <Col>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit Application
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default memo(ScholarshipForm);
